import { useMutation } from "react-query";

import axios from "axios";
import { exportToExcelSheets } from "utils/exportToExcel";

import { REACT_APP_STICK_SCHEDULER_SERVICE_ADDRESS } from "../modals/constants";
import { StickCalculationResult } from "../models/StickCalculationResult";
import { flattenStickResultData } from "../utils/stickResultFormatter";

export async function exportSticksCalculationJob(jobId: string) {
  try {
    const response = await axios.get<StickCalculationResult>(
      `${REACT_APP_STICK_SCHEDULER_SERVICE_ADDRESS}/job/${jobId}/export`
    );

    const formattedData = flattenStickResultData(response.data);

    exportToExcelSheets(formattedData, `stick-sampled-${jobId}.xlsx`);

    return response.data;
  } catch (error) {
    // If the request fails, return undefined
    return undefined;
  }
}

export function useExportGeoSticksCalculationJob() {
  return useMutation((jobId: string) => exportSticksCalculationJob(jobId));
}
